import React from 'react'

export default () => (
    <svg width="77" height="78" viewBox="0 0 77 78" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.6 0V26M59.2 0V26M28 33.8L48.8 54.6M28 54.6L48.8 33.8M7.2 13H69.6C70.9791 13 72.3018 13.5479 73.277 14.523C74.2521 15.4982 74.8 16.8209 74.8 18.2V70.2C74.8 71.5791 74.2521 72.9018 73.277 73.877C72.3018 74.8521 70.9791 75.4 69.6 75.4H7.2C5.82087 75.4 4.49823 74.8521 3.52304 73.877C2.54786 72.9018 2 71.5791 2 70.2V18.2C2 16.8209 2.54786 15.4982 3.52304 14.523C4.49823 13.5479 5.82087 13 7.2 13Z" stroke="currentColor" strokeWidth="4" />
    </svg>
);